import './styles.css';
import Carroussel from '../../components/Carroussel';
import GameTime from '../../imgs/game-time.png';
import imgMemoria from '../../imgs/jogos/memoria.png';
import imgFlashcards from '../../imgs/jogos/flashcards.png';
import imgVerdade from '../../imgs/jogos/verdade-ou-mentira.png';
import VideoAnimaker from '../../videos/home-video-1.mp4';
import VideoHome from '../../videos/adolescentes.mp4';
import { useIsMobile } from '../../hooks/useIsMobile';
import RodapeImgs from '../../imgs/rodape-imgs.png';
import PosterHome from '../../imgs/poster-videos/homer.png';

function Home() {
  const isMobile = useIsMobile();

  const goTo = (link) => {
    window.location.href = link;
  };

  const cardsData = [
    {
      id: 1,
      image: imgMemoria,
      onClick: () => goTo('/jogos/jogo-da-memoria'),
    },
    {
      id: 2,
      image: imgFlashcards,
      onClick: () => goTo('/jogos/flashcards'),
    },
    {
      id: 3,
      image: imgVerdade,
      onClick: () => goTo('/jogos/verdade-ou-mentira'),
    },
  ];

  return (
    <>
      <div className="home-section">
        <div className="container" style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'
        }}>

          <p className="kanchenjunga-regular" style={{ textAlign: 'center', padding: 20, backgroundColor: 'rgb(249, 249, 249, 0.8)', borderRadius: 10 }}>
            <h2 className="" style={{ paddingTop: 40 }}>
              Seja bem-vindo(a) ao “@Teen Saúde Bucal”

              <p className='outfit' style={{ textAlign: 'center', marginTop: 0, fontSize: 24, fontWeight: 'bold' }}>Sua saúde bucal conectada com você!</p>
            </h2>
            <p style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
              Desenvolvido pelo Programa de Pós Graduação em Odontologia da Universidade Federal de Uberlândia <b>(PPGO-UFU)</b> em parceria com o Hospital Odontológico da Universidade Federal de Uberlândia <b>(HOUFU)</b>, Faculdade de Odontologia <b>(FOUFU)</b> e o Instituto Nacional de Ciência e Tecnologia Saúde Oral e Odontologia do município de Uberlândia <b>(INCT-Odonto)</b>.</p>
          <img src={RodapeImgs} alt="RodapeImgs" style={{ width: '200px' }} />

          </p>
          <div className="home-image">
            <video width="640" height="360" controls {...(isMobile ? { poster: PosterHome } : {})}>
              <source src={VideoAnimaker} type="video/mp4" />
              Seu navegador não suporta a tag de vídeo.
            </video>
          </div>
        </div>
      </div>

      <div id="como-ser-atendidos" className="como-ser-atendidos">
        <div className="container" style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginTop: 50
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: isMobile ? 'column' : 'row' }}>
            <div className="home-text">
              <h5 className="chewy" style={{ fontSize: 40, margin: 0 }}>Olá, adolescentes!</h5>
              <div className="kanchenjunga-regular">
                {isMobile ? (
                  <>
                    <p>A adolescência é uma fase de muitas mudanças físicas, mentais e emocionais. Deixamos de ser crianças, mas ainda não somos adultos — o que pode gerar dúvidas e desafios. Mais do que uma fase de transição, é um momento importante de crescimento e aprendizado.</p>
                    <p>Por isso, vamos falar sobre os cuidados com a saúde e embarcar nessa aventura?</p>
                  </>
                ) : (
                  <>
                    <p>Vamos conversar sobre essa fase tão especial da vida de vocês. A adolescência é um período de grandes mudanças no corpo, na mente e nas emoções...</p>
                    <p>Ser adolescente não é apenas uma fase de passagem, mas uma etapa importante de formação e aprendizado.</p>
                    <h2>Vamos embarcar nessa aventura?</h2>
                  </>
                )}
              </div>
            </div>
            <div className="home-image">
              <video width="640" height="360" controls muted autoPlay>
                <source src={VideoHome} type="video/mp4" />
                Seu navegador não suporta a tag de vídeo.
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="jogos-section">
        <div className="container jogos-container">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img style={{ width: 300 }} src={GameTime} alt="home" />
          </div>
          <Carroussel style={{ height: '100%' }} cardsData={cardsData} />
        </div>
      </div>
    </>
  );
}

export default Home;
